import union from 'lodash/union';
import { combineReducers } from 'redux';

import * as types from '../../types';

const byId = (state = {}, action) => {
  switch (action.type) {
    case types.USER_PUSH_NOTIFICATIONS_FETCH_COMPLETED: {
      const { entities, order } = action.payload;
      const newState = {};
      order.forEach((notifId) => {
        newState[notifId] = {
          isSelected: false,
          ...entities[notifId],
          isConfirmed: true,
          shownAtLogin: false
        };
      });
      return newState;
    }

    default: {
      return state;
    }
  }
};

const order = (state = [], action) => {
  switch (action.type) {
    case types.USER_PUSH_NOTIFICATIONS_FETCH_COMPLETED: {
      const { order } = action.payload;
      return union(order);
    }

    default: {
      return state;
    }
  }
};

export const events = combineReducers({
  byId,
  order
});
